  document.addEventListener('DOMContentLoaded', () => {
    customreviewswiper();
    document.addEventListener('shopify:section:load', customreviewswiper);
    document.addEventListener('shopify:section:unload', customreviewswiper);
  });
  function customreviewswiper() {
  var swiper = new Swiper(".u-cus-reviews-wrapper", {
    slidesPerView: 1,
    loop: true,
    speed: 800,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  var prevBtn = document.querySelector(".u-cus-btn-prev");
  var nextBtn = document.querySelector(".u-cus-btn-next");
  if (prevBtn) prevBtn.addEventListener("click", function () { swiper.slidePrev(); });
  if (nextBtn) nextBtn.addEventListener("click", function () { swiper.slideNext(); });
}
function initAnnouncementSlider() {
    var swiper = new Swiper(".M-announcement-slider", {
      autoplay: true,
       speed: 500,
      loop: true, 
      slidesPerView: 1
    });
  }

var swiper = new Swiper(".mprogSwiper", {
      pagination: {
        el: ".swiper-pagination",
      },
  navigation: {
    nextEl: ".m-swiper-button-next",
    prevEl: ".m-swiper-button-prev",
  },
});
function aggiornaData() {
  const ora = new Date();
  const domani = new Date(ora);
  domani.setDate(ora.getDate() + 1);

  const giorno = String(domani.getDate()).padStart(2, '0');
  const mese = String(domani.getMonth() + 1).padStart(2, '0');

  const dataFormattata = `${giorno}/${mese}`;

  let cstmDate = document.getElementById('cstmdate');
  if (cstmDate) {
    cstmDate.innerText = dataFormattata;
  }

  // Refresh exactly at midnight
  const msFinoAllaMezzanotte =
    new Date(ora.getFullYear(), ora.getMonth(), ora.getDate() + 1, 0, 0, 0) - ora;

  setTimeout(() => {
    aggiornaData();
    setInterval(aggiornaData, 24 * 60 * 60 * 1000);
  }, msFinoAllaMezzanotte);
}

aggiornaData();